import callNativeMethod from './callNativeMethod';
import checkIfInterfaceExist from './checkIfInterfaceExist';
import NATIVEFUNCTION_TYPE from './nativeFunctionType';
import myInterface from './myInterface';

/**
 * @return {*}
 */
const getAppVersion = () => {
  const methodBody = {
    functionName: NATIVEFUNCTION_TYPE.getAppVersion,
  };
  try {
    callNativeMethod(methodBody);
    return true;
  } catch (error) {
    if (checkIfInterfaceExist('getAppVersion')) {
      return myInterface.getAppVersion();
    }
  }
};

export default getAppVersion;
